import { stringify } from 'query-string';

export const getFetchUrl = (baseUrl: string, projectId: string, query = '') =>
	`${baseUrl}/rest/servicedesk/1/organisations/project/${projectId}/invite/search?${stringify({
		query,
	})}`;
